import React, { Component } from 'react';
import Titulo from '../comum/Titulo';
import { connect } from 'react-redux'
import Autorizacao from '../../security/Autorizacao';
import {
    PERFIL_ADMIN
} from '../../security/securityContext';
import buscarReservasRepasse from '../../actions/repasse-venda/buscarReservasRepasse';
import { abaRepasseVenda, tipoRepasseVenda } from '../../util/constantsUtil';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import moment from 'moment'
import { realParaNumberExportacao } from '../../util/numberUtil';

export class PainelReservasRepasse extends Component {
    constructor(props) {
        super(props)

        this.state = {
            retorno: '/painel-repasse-venda'
        }
    }

    getTipoRepasse() {
        return this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado) ? tipoRepasseVenda.empresa.nome : this.props.parametrosBuscaRepasseSelecionado.tipo;
    }

    getAba() {
        return this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado) ? abaRepasseVenda.pendenteRepasse : this.props.parametrosBuscaRepasseSelecionado.aba;
    }

    ehRepasseEmpresa() {
        return this.getTipoRepasse() === tipoRepasseVenda.empresa.nome;
    }

    ehRepasseVendedor() {
        return this.getTipoRepasse() === tipoRepasseVenda.vendedor.nome
    }

    ehRepasseImposto() {
        return this.getTipoRepasse() === tipoRepasseVenda.imposto.nome;
    }

    ehAbaHistoricoRepasse(){
        return this.getAba() === abaRepasseVenda.historicoRepasse;
    }

    getColunaTipoRepasse() {
        return (this.ehRepasseEmpresa() ? 'Empresa' : null) || (this.ehRepasseVendedor() ? 'Vendedor' : null) || (this.ehRepasseImposto() ? 'Grupo' : '');
    }

    mostrarColunaEmpresa() {
        return this.ehRepasseVendedor() || this.ehRepasseImposto();
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;' }));
        a.download = 'Dados - Reservas do Repasse.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarTabelaReservasRepasse() {
        const colunaTipoRepasse = this.getColunaTipoRepasse();

        const titulo = this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado) ?
            'Aba:' + `${capitalizarTodasPrimeirasLetras(abaRepasseVenda.pendenteRepasse)}- Tipo Repasse: ${capitalizarTodasPrimeirasLetras(tipoRepasseVenda.empresa.nome)}`
            : `Aba: ${capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.aba)}- Tipo Repasse: ${capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.tipo)}`
        let arquivo = titulo + '\n';

        const periodo = this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado) ?
            `Periodo: ${moment().subtract(30, 'days').calendar()} à ${moment().format('DD/MM/YYYY')}`
            : this.props.parametrosBuscaRepasseSelecionado.dataInicio ? `Periodo: ${moment(this.props.parametrosBuscaRepasseSelecionado.dataInicio).format('DD/MM/YYYY')} à ${moment(this.props.parametrosBuscaRepasseSelecionado.dataFim).format('DD/MM/YYYY')}`
                : `Periodo: ${moment().subtract(30, 'days').calendar()} à ${moment().format('DD/MM/YYYY')}`
        arquivo += periodo + '\n';

        const labelDataRepasse = this.ehAbaHistoricoRepasse() ? 'Data Repasse;' : ''
        arquivo += `N° Bilhete;Data da Venda;${labelDataRepasse}Data Previsao Embarque;Data de Embarque;Nome Passageiro;Numero Poltrona;Rota;Prestador;Veiculo;Trecho Origem;Trecho Destino;${colunaTipoRepasse};Tx Serviço;Desconto;Comissão;Comissão Agente;Comissão Agente (%);Imposto;Custo Cancelamento;Valor Pedido ( - Desconto );Valor Faturado;Valor Repasse\n`;

        arquivo = `${arquivo}${this.props.reservasRepasse.map((it) => {
            const nomeTipoRepasse = (this.ehRepasseEmpresa() ? it.nomeEmpresa : null) || (this.ehRepasseVendedor() ? it.nomeVendedor : null) || (this.ehRepasseImposto() ? it.grupo : '')
            let valorRepasse = (this.ehRepasseEmpresa() ? it.valorLiquido : null) || (this.ehRepasseVendedor() ? it.comissao : null) || (this.ehRepasseImposto() ? it.imposto : null)
            valorRepasse = valorRepasse ? realParaNumberExportacao(valorRepasse.toString()) : 0;

            const dataVenda = it.dataVenda ? moment(it.dataVenda).format('DD/MM/YYYY HH:mm') : '-'
            const dataRepasse = this.ehAbaHistoricoRepasse() ? moment(it.dataRepasse).format('DD/MM/YYYY HH:mm') + ';' : ''
            const dataPrevisaoEmbarque = it.dataPrevisaoEmbarque ? moment(it.dataPrevisaoEmbarque).format('DD/MM/YYYY HH:mm') : '-'
            const dataEmbarque = it.dataHoraEmbarque ? moment(it.dataHoraEmbarque).format('DD/MM/YYYY HH:mm') : 'não embarcado'
            const nomePassageiro = it.nomePassageiro ? it.nomePassageiro.toString() : '-'
            const numeroPoltrona = it.numeroPoltrona ? it.numeroPoltrona.toString() : '-'
            const rota = it.rota ? it.rota.toString() : '-'
            const prestador = it.prestador ? it.prestador.toString() : '-'
            const descricaoVeiculo = it.descricaoVeiculo ? it.descricaoVeiculo.toString() : '-'
            const descricaoCidadeOrigem = it.descricaoCidadeOrigem ? it.descricaoCidadeOrigem.toString() : '-'
            const descricaoCidadeDestino = it.descricaoCidadeDestino ? it.descricaoCidadeDestino.toString() : '-'
            const taxaServico = it.taxaServico ? realParaNumberExportacao(it.taxaServico.toString()) : 0
            const comissao = it.comissao ? realParaNumberExportacao(it.comissao.toString()) : 0
            const comissaoAgente = it.comissaoAgente ? realParaNumberExportacao(it.comissaoAgente.toString()) : 0
            const porcentagemAgente = it.porcentagemAgente ? realParaNumberExportacao(it.porcentagemAgente.toString()) : 0
            const imposto = it.imposto ? realParaNumberExportacao(it.imposto.toString()) : 0
            const custoCancelmaneto = it.custoCancelmaneto ? realParaNumberExportacao(it.custoCancelmaneto.toString()) : 0
            const valorFaturado = realParaNumberExportacao(it.valorFaturado.toString())
            const valorPedido = it.valor ? realParaNumberExportacao(it.valor.toString()) : 0
            const desconto = it.desconto ? realParaNumberExportacao(it.desconto) : 0

            return `${it.reservaId};${dataVenda};${dataRepasse}${dataPrevisaoEmbarque};${dataEmbarque};${nomePassageiro};${numeroPoltrona};${rota};${prestador};${descricaoVeiculo};${descricaoCidadeOrigem};${descricaoCidadeDestino};${nomeTipoRepasse};"${taxaServico}";"${desconto}";"${comissao}";"${comissaoAgente}";"${porcentagemAgente}";"${imposto}";"${custoCancelmaneto}";"${valorPedido}";"${valorFaturado}";"${valorRepasse}"`
        }).join('\n')}\n`;

        this.executarDownload(arquivo)
    }

    exportarGerarRelatorioRepasse() {
        const titulo = this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado)
            ? 'Aba:' + `${capitalizarTodasPrimeirasLetras(abaRepasseVenda.pendenteRepasse)}- Tipo Repasse: ${capitalizarTodasPrimeirasLetras(tipoRepasseVenda.empresa.nome)}`
            : `Aba: ${capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.aba)}- Tipo Repasse: ${capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.tipo)}`;
        let arquivo = titulo + '\n';

        const periodo = this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado)
            ? `Periodo: ${moment().subtract(30, 'days').calendar()} à ${moment().format('DD/MM/YYYY')}`
            : this.props.parametrosBuscaRepasseSelecionado.dataInicio
                ? `Periodo: ${moment(this.props.parametrosBuscaRepasseSelecionado.dataInicio).format('DD/MM/YYYY')} à ${moment(this.props.parametrosBuscaRepasseSelecionado.dataFim).format('DD/MM/YYYY')}`
                : `Periodo: ${moment().subtract(30, 'days').calendar()} à ${moment().format('DD/MM/YYYY')}`;
        arquivo += periodo + '\n';

        const labelDataRepasse = this.ehAbaHistoricoRepasse() ? 'Data Repasse;' : '';
        arquivo += `N° Bilhete;Data da Venda;${labelDataRepasse}Data Previsao Embarque;Data de Embarque;Nome Passageiro;Numero Poltrona;Rota;Prestador;Veiculo;Trecho Origem;Trecho Destino;`;

        if (this.ehRepasseEmpresa()) {
            arquivo += 'Site;Desconto;Comissão;Imposto;Custo Cancelamento;Valor Pedido ( - Desconto );Valor Repasse\n';
        } else if (this.ehRepasseVendedor()) {
            arquivo += 'Empresa;Desconto;Comissão Agente;Comissão Agente (%);Imposto;Custo Cancelamento;Valor Pedido ( - Desconto )\n';
        } else if (this.ehRepasseImposto()) {
            arquivo += 'Empresa;Site;Desconto;Comissão;Imposto;Custo Cancelamento;Valor Pedido ( - Desconto );Valor Repasse\n';
        }

        arquivo = `${arquivo}${this.props.reservasRepasse
            .map((it) => {
                let linha = '';
                const valorRepasse =
                    (this.ehRepasseEmpresa() ? it.valorLiquido : null) ||
                    (this.ehRepasseVendedor() ? it.comissao : null) ||
                    (this.ehRepasseImposto() ? it.imposto : null);
                const nomeSite = it.plataforma;
                const valorRepasseExportacao = valorRepasse ? realParaNumberExportacao(valorRepasse.toString()) : 0;

                const dataVenda = it.dataVenda ? moment(it.dataVenda).format('DD/MM/YYYY HH:mm') : '-';
                const dataRepasse = this.ehAbaHistoricoRepasse() ? moment(it.dataRepasse).format('DD/MM/YYYY HH:mm') + ';' : '';
                const dataPrevisaoEmbarque = it.dataPrevisaoEmbarque ? moment(it.dataPrevisaoEmbarque).format('DD/MM/YYYY HH:mm') : '-';
                const dataEmbarque = it.dataHoraEmbarque ? moment(it.dataHoraEmbarque).format('DD/MM/YYYY HH:mm') : 'não embarcado';
                const nomePassageiro = it.nomePassageiro ? it.nomePassageiro.toString() : '-';
                const numeroPoltrona = it.numeroPoltrona ? it.numeroPoltrona.toString() : '-';
                const rota = it.rota ? it.rota.toString() : '-';
                const prestador = it.prestador ? it.prestador.toString() : '-';
                const nomeEmpresa = it.nomeEmpresa ? it.nomeEmpresa.toString() : '-';
                const descricaoVeiculo = it.descricaoVeiculo ? it.descricaoVeiculo.toString() : '-';
                const descricaoCidadeOrigem = it.descricaoCidadeOrigem ? it.descricaoCidadeOrigem.toString() : '-';
                const descricaoCidadeDestino = it.descricaoCidadeDestino ? it.descricaoCidadeDestino.toString() : '-';
                const comissao = it.comissao ? realParaNumberExportacao(it.comissao.toString()) : 0;
                const comissaoAgente = it.comissaoAgente ? realParaNumberExportacao(it.comissaoAgente.toString()) : 0;
                const porcentagemAgente = it.porcentagemAgente ? realParaNumberExportacao(it.porcentagemAgente.toString()) : 0;
                const imposto = it.imposto ? realParaNumberExportacao(it.imposto.toString()) : 0;
                const custoCancelmaneto = it.custoCancelmaneto ? realParaNumberExportacao(it.custoCancelmaneto.toString()) : 0;
                const valorPedido = it.valor ? realParaNumberExportacao(it.valor.toString()) : 0;
                const desconto = it.desconto ? realParaNumberExportacao(it.desconto) : 0;

                if (this.ehRepasseEmpresa()) {
                    linha += `${it.reservaId};${dataVenda};${dataRepasse}${dataPrevisaoEmbarque};${dataEmbarque};${nomePassageiro};${numeroPoltrona};${rota};${prestador};${descricaoVeiculo};${descricaoCidadeOrigem};${descricaoCidadeDestino};${nomeSite};"${desconto}";"${comissao}";"${imposto}";"${custoCancelmaneto}";"${valorPedido}";"${valorRepasseExportacao}"`;
                } else if (this.ehRepasseVendedor()) {
                    linha += `${it.reservaId};${dataVenda};${dataRepasse}${dataPrevisaoEmbarque};${dataEmbarque};${nomePassageiro};${numeroPoltrona};${rota};${prestador};${descricaoVeiculo};${descricaoCidadeOrigem};${descricaoCidadeDestino};${nomeEmpresa};"${desconto}";"${comissaoAgente}";"${porcentagemAgente}";"${imposto}";"${custoCancelmaneto}";"${valorPedido}"`;
                } else if (this.ehRepasseImposto()) {
                    linha += `${it.reservaId};${dataVenda};${dataRepasse}${dataPrevisaoEmbarque};${dataEmbarque};${nomePassageiro};${numeroPoltrona};${rota};${prestador};${descricaoVeiculo};${descricaoCidadeOrigem};${descricaoCidadeDestino};${nomeEmpresa};${nomeSite};"${desconto}";"${comissao}";"${imposto}";"${custoCancelmaneto}";"${valorPedido}";"${valorRepasseExportacao}"`;
                }

                return linha;
            })
            .join('\n')}\n`;

        this.executarDownload(arquivo);
    }

    componentDidMount() {
        if (this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado)) {
            this.props.buscarReservasRepasse();
        } else {
            const { dataInicio, dataFim, tipo, aba } = this.props.parametrosBuscaRepasseSelecionado
            const vendedorId = this.props.repasseVendaSelecionado.usuarioId;
            const empresaId = this.props.repasseVendaSelecionado.empresaId;
            const grupo = this.props.repasseVendaSelecionado.grupo;
            const repasseId = this.props.repasseVendaSelecionado.id ? this.props.repasseVendaSelecionado.id : null;

            this.props.buscarReservasRepasse(dataInicio, dataFim, tipo, aba, vendedorId, empresaId, grupo, repasseId);
        }

    }

    objIsEmpty(obj) {
        for (let prop in obj) { return false }
        return true;
    }

    exibirReservasRepasse() {
        return (
            <>
                <div>
                    {this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado) ?
                        <h3 style={{ display: 'inline' }}>Aba: {capitalizarTodasPrimeirasLetras(abaRepasseVenda.pendenteRepasse)}- Tipo Repasse: {capitalizarTodasPrimeirasLetras(tipoRepasseVenda.empresa.nome)}</h3>
                        : <h3 style={{ display: 'inline' }}>Aba: {capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.aba)}- Tipo Repasse: {capitalizarTodasPrimeirasLetras(this.props.parametrosBuscaRepasseSelecionado.tipo)}</h3>}
                    <div className="dropdown">
                        <button className="btn btn-laranja dropdown-toggle float-right" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Exportar
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a className="dropdown-item btn btn-laranja" onClick={() => this.exportarTabelaReservasRepasse()}>Exportar Lista</a>
                            <a className="dropdown-item btn btn-laranja" onClick={() => this.exportarGerarRelatorioRepasse()}>Gerar Relatório</a>
                        </div>
                    </div>
                </div>
                <div className='row col-12'>
                    {this.objIsEmpty(this.props.parametrosBuscaRepasseSelecionado) ?
                        <p>Periodo: {moment().subtract(30, 'days').calendar()} à {moment().format('DD/MM/YYYY')}</p>
                        : this.props.parametrosBuscaRepasseSelecionado.dataInicio ? <p>Periodo: {moment(this.props.parametrosBuscaRepasseSelecionado.dataInicio).format('DD/MM/YYYY')} à {moment(this.props.parametrosBuscaRepasseSelecionado.dataFim).format('DD/MM/YYYY')}</p>
                            : <p>Periodo: {moment().subtract(30, 'days').calendar()} à {moment().format('DD/MM/YYYY')}</p>}
                </div>
                <br />
                <div className='table-responsive'>
                    <table className="table table-striped table-bordered" style={{ backgroundColor: '#FFF' }}>
                        <thead>
                            <tr className='border'>
                                <th scope="col">N° Bilhete</th>
                                {this.mostrarColunaEmpresa() ? <th scope="col">Empresa</th> : ''}
                                <th scope="col">Data da venda</th>
                                {this.ehAbaHistoricoRepasse() ? <th scope="col">Data Repasse</th> : ''}
                                <th scope="col">Data previsão embarque</th>
                                <th scope="col">Data de Embarque</th>
                                <th scope="col">Nome passageiro</th>
                                <th scope="col">Numero poltrona</th>
                                <th scope="col">Rota</th>
                                <th scope="col">Prestador</th>
                                <th scope="col">Veículo</th>
                                <th scope="col">Trecho origem</th>
                                <th scope="col">Trecho destino</th>
                                {<th scope="col">{this.getColunaTipoRepasse()}</th>}
                                <th scope="col">Tx Serviço</th>
                                <th scope="col">Desconto</th>
                                <th scope="col">Comissão</th>
                                <th scope="col">Comissão Agente</th>
                                <th scope="col">Comissão Agente (%)</th>
                                <th scope="col">Imposto</th>
                                <th scope="col">Custo Cancelamento</th>
                                <th scope="col">Valor pedido(-Desconto)</th>
                                <th scope="col">Valor Faturado</th>
                                <th scope="col">Valor Repasse</th>
                            </tr>
                        </thead>
                        {this.props.reservasRepasse && this.props.reservasRepasse.map((it, index) => <tbody key={index}>
                            <tr key={index}>
                                <td>
                                    <span>{it.reservaId}</span>
                                </td>
                                {this.mostrarColunaEmpresa() ?
                                    <td>
                                        <span>{it.nomeEmpresa}</span>
                                    </td> : ''}
                                <td>
                                    <span>{moment(it.dataVenda).format('DD/MM/YYYY HH:mm')}</span>
                                </td>
                                {this.ehAbaHistoricoRepasse() ? <td>
                                    <span>{moment(it.dataRepasse).format('DD/MM/YYYY HH:mm')}</span>
                                </td> : '' }
                                <td>
                                    <span>{it.dataPrevisaoEmbarque ? moment(it.dataPrevisaoEmbarque).format('DD/MM/YYYY HH:mm') : '-'}</span>
                                </td>
                                <td>
                                    <span>{it.dataHoraEmbarque ? moment(it.dataHoraEmbarque).format('DD/MM/YYYY HH:mm') : 'não embarcado'}</span>
                                </td>
                                <td>
                                    <span>{it.nomePassageiro}</span>
                                </td>
                                <td>
                                    <span>{it.numeroPoltrona}</span>
                                </td>
                                <td>
                                    <span>{it.rota}</span>
                                </td>
                                <td>
                                    <span>{it.prestador ? it.prestador : '-'}</span>
                                </td>
                                <td>
                                    <span>{it.descricaoVeiculo}</span>
                                </td>
                                <td>
                                    <span>{it.descricaoCidadeOrigem}</span>
                                </td>
                                <td>
                                    <span>{it.descricaoCidadeDestino}</span>
                                </td>
                                <td>
                                    {this.ehRepasseEmpresa() ? <span>{it.nomeEmpresa}</span> : ''}
                                    {this.ehRepasseVendedor() ? <span>{it.nomeVendedor}</span> : ''}
                                    {this.ehRepasseImposto() ? <span>{it.grupo}</span> : ''}
                                </td>
                                <td>
                                    <span>{Number(it.taxaServico)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(it.desconto)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(it.comissao)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(it.comissaoAgente)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{it.porcentagemAgente + '%'}</span>
                                </td>
                                <td>
                                    <span>{Number(it.imposto)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(it.custoCancelmaneto)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(it.valor)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(it.valorFaturado)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                                <td>
                                    <span>{Number(this.ehRepasseEmpresa() ? it.valorLiquido : '' ||
                                        this.ehRepasseVendedor() ? it.comissao : '' ||
                                            this.ehRepasseImposto() ? it.imposto : '')
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}</span>
                                </td>
                            </tr>
                        </tbody>)}
                    </table>
                </div>
            </>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div>
                        <Titulo texto="Reservas do Repasse" urlRetorno={this.state.retorno} />
                        {this.exibirReservasRepasse()}
                    </div>
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => {
    return {
        parametrosBuscaRepasseSelecionado: state.parametrosBuscaRepasseSelecionado,
        reservasRepasse: state.reservasRepasse,
        repasseVendaSelecionado: state.repasseVendaSelecionado
    }
}

export default connect(mapStateToProps, {
    buscarReservasRepasse
})(PainelReservasRepasse);